import { EventStatus } from '../../data/firestore/globals';
import { BadgeContainer } from './styled';

const labelMap: Record<string, string> = {
    'pending-approval': 'Pending Approval',
    rejected: 'Rejected',
};

interface Params {
    value?: EventStatus;
    variant?: 'default' | 'solid';
}

const CalendarBuiltInStatusBadge = ({
    value,
    variant = 'default',
}: Params) => (
    <BadgeContainer color={value?.color as string} variant={variant}>
        {labelMap[value?.name as string] || value?.name}
    </BadgeContainer>
);

export default CalendarBuiltInStatusBadge;
